/**
 * AMB-247 — decide where tapping a live-chat author goes.
 *
 * Returns the public-profile navigation target for the tapped author, or null
 * when the tap should do nothing: a missing id, the synthetic `sys` author, or
 * the viewer tapping their own message. The caller maps a non-null result to
 * `navigation.navigate('PublicUserProfile', target)`.
 */

export interface ChatUserPressTarget {
  userId: string;
}

export function chatUserPressTarget(
  tappedUserId: string | null | undefined,
  currentUserId: string | null | undefined,
): ChatUserPressTarget | null {
  if (!tappedUserId) return null;
  if (tappedUserId === 'sys') return null;
  if (currentUserId && tappedUserId === currentUserId) return null;
  return { userId: tappedUserId };
}
